<template>
  <div id="notFound">
    <img src="/static/img/logo_starter.png" class="center-block logo">

    <div class="text-center col-sm-12">
      <h1>Ops! Você se perdeu! </h1>
      <h4>Esta página não existe.</h4>
      <router-link to="/" class="vertical-5p lead">Voltar para o início.</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NotFound'
}
</script>

<style>
#notFound {
  padding: 10em;
  color: white;
}
</style>



// WEBPACK FOOTER //
// 404.vue?4b217b7e